import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, Mail, X } from "lucide-react";

const PaymentSuccessToast = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  const isSuccess = searchParams.get("success") === "true";

  useEffect(() => {
    if (isSuccess) {
      setIsVisible(true);
      // Auto-dismiss after 10 seconds
      const timer = setTimeout(() => {
        handleDismiss();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [isSuccess]);

  const handleDismiss = () => {
    setIsVisible(false);
    // Clean up URL params
    navigate("/", { replace: true });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-md px-4 animate-fade-up">
      <div className="bg-background border border-primary/30 rounded-xl shadow-xl p-5 relative">
        {/* Dismiss button */}
        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>

        {/* Content */}
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <CheckCircle className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1 pr-4">
            <h3 className="font-serif text-lg text-foreground mb-1">
              Thank you, traveler!
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Your payment was successful. Eunice is crafting your letter now.
            </p>
            <div className="flex items-center gap-2 mt-3 text-xs text-charcoal-light">
              <Mail className="h-3.5 w-3.5" />
              <span>You'll receive it by email within a few minutes.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessToast;
